import React from 'react'
import { Helmet } from "react-helmet-async";
import { CopyBlock , a11yLight, github} from 'react-code-blocks';

// Components
import HeaderRegComponent from '../../Components/HeaderRegComponent'
import FooterComponent from '../../Components/FooterComponent'
import workshopImage from '../../images/blog/workshop_may_2025.jpeg';
import  onemapPresentation2 from '../../images/blog/OneMap_WorkshopDemo_May_2025.pdf';

const JWTTokenUpdate = () => {
    const jwtExample = `eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.
eyJpc3MiOiJPbmVNYXAiLCJ1c2VyX2lkIjo0NjE0LCJpYXQiOjE3NTE4NzkxOTUsImV4cCI6MTc1MjEzODM5NSwianRpIjoiNGJjMTA3NmItZTMwYS00M2M3LTg4NjAtMGIyMGUwMzRhYzNiIn0.
SMr3g5O5...V0s6k0WcJbw3dTrSg1Im-zvO5_HjTDk...`;

    const headerJson = `{
    "alg": "RS256",
    "typ": "JWT"
}`;

    const payloadJson = `{
        "user_id": 637,
        "forever": false,
        "iss": "OneMap",
        "iat": 1753889383,
        "nbf": 1753889383,
        "exp": 1754148583,
        "jti": "fdc7078e-8fa2-4d1c-a3ca-e5eed0792ac0"
}`;

    return (
        <>
            <Helmet>
                <title>JWT Token Update - RS256 Migration | OneMap API</title>
                <meta
                    name="description"
                    content="Migration from HS256 to RS256 for JWT Signing in OneMap API"
                />
            </Helmet>
            <div className="om-body container-fluid">
                <HeaderRegComponent />

                <div className="om-body-content pageBase">
                    <div className='documentation center om-body-container'>
                        <div className='row mb-4'>
                            <div className="col-md-10 offset-md-1">

                                <h1>Migration from HS256 to RS256 for JWT Signing</h1>
                                
                                <div className="alert alert-info" role="alert">
                                    <strong>Effective Date:</strong> 2nd July 2025
                                </div>

                                <p className="lead">
                                    We have migrated the JWT signing algorithm used for authenticating access to OneMap endpoints 
                                    from HS256 to RS256.
                                </p>

                                <h2>Why This Change?</h2>
                                <p>
                                    This transition is part of our broader security hardening initiative to adopt asymmetric 
                                    cryptography. RS256 offers improved trust and validation mechanisms by decoupling signing 
                                    (with a private key) and verification (with a public key), allowing better key management 
                                    and reduced exposure risk.
                                </p>

                                <h2>Key Changes</h2>
                                <div className="card mb-4">
                                    <div className="card-body">
                                        <h3>Token Size</h3>
                                        <p>
                                            RS256 tokens are significantly longer due to RSA signature size:
                                        </p>
                                        <ul>
                                            <li>New average length: ~580 characters</li>
                                            <li>Previous length: ~430 characters</li>
                                            <li>Range: 550-700 characters (using 2048-bit RSA key)</li>
                                        </ul>

                                        <h3>Storage Impact</h3>
                                        <div className="alert alert-danger">
                                            <b>Ensure all systems that persist or handle JWTs (e.g., databases, headers, logs) 
                                            support a length of at least 1000 characters to prevent truncation or validation 
                                            failures.
                                            </b>
                                        </div>
                                    </div>
                                </div>

                                <h2>Example RS256 JWT Structure</h2>
                                <p>Here's an example JWT issued using RS256:</p>

                                <div className="mb-4">
                                <div style={{"fontFamily": "monospace", "wordWrap": "break-word"}}>
                                    {jwtExample}
                                    </div>
                                </div>

                                <h3><br/>🔎 Decoded Components</h3>
                                
                                <h4>Header</h4>
                                <div class='codeblock'>
                                <CopyBlock
                                    text={headerJson}
                                    className="abc"
                                    language="javascript"
                                    theme={github}
                                    wrapLines={true}
                                    codeBlock
                                />
                                </div>

                                <h4>Payload</h4>

                                <div class='codeblock'>
                                <CopyBlock
                                    text={payloadJson}
                                    className="abc"
                                    language="javascript"
                                    theme={github}
                                    wrapLines={true}
                                    codeBlock
                                />
                                </div>

                                <h4>Signature</h4>
                                <p>RS256 signature, generated using our private RSA key.</p>

                                <div style={{marginBottom:"7em"}}/>
                            </div>
                        </div>
                    </div>
                </div>

                <FooterComponent />
            </div>
        </>
    )
}

export default JWTTokenUpdate